<template>
  <div>
    <div class="page7 page landscape">
      <Logo />
      <div class="flex">
        <div class="info">
          <div class="container">
            <center><h1>Content Onsite</h1></center>
            <h4>
              Dlaczego warto?
            </h4>
            <ul>
              <li>
                <span class="bolder">Wszystko mierzymy -</span> fundamentem
                pracy nad tekstem jest analiza konkurencji SEO i Content
                Marketingowej w tematyce danego artykułu. Dzięki niej, wiemy
                jakie kryteria powinien spełniać artykuł, by móc wygrywać w
                Google
              </li>
              <li>
                <span class="bolder">
                  Piszemy w zgodzie z aktualnymi trendami SEO -
                </span>
                precyzyjnie dobieramy frazy do treści. Dogłębnie analizujemy
                potrzeby i pytania Twoich potencjalnych klientów i odpowiadamy
                na nie w artykułach
              </li>
              <li>
                <span class="bolder">Piszemy z myślą o Twoim kliencie -</span>
                pamiętamy, że treść ma budować wizerunek eksperta i długofalowo
                prowadzić do konwersji. Dostosowujemy język naszych treści do
                grupy docelowej. Damy, by artykuły były zgodne z zasadami
                webwritingu dzięki temu wygrywamy uwagę użytkownika, a jakość
                wizyty na Twojej stronie się zwiększa.
              </li>
            </ul>
            <center>
              <img
                src="/icon4.png"
                alt=""
                srcset=""
                style="
                  width: 40%;
                  margin: 0;
                  padding: 0;
                  margin-left: 0px;
                  margin-top: 40px;
                "
              />
            </center>
          </div>
        </div>
        <div class="bg-image">
          <img src="/col7.jpg" alt="" srcset="" />
          <div class="overlay"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'

export default {
  name: 'Seo7',
  components: {
    Logo,
  },
  props: {
    msg: String,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page7 {
  color: #000 !important;
  text-align: left;
}

.container {
  margin-top: 100px;
}
</style>
